import { last, xprod, join, map, prop, fromPairs, allPass, is, lte, gte, clone, compose, reverse, append, __ } from 'ramda';
import utils from '../../modules/utils';

const props = xprod('AN', 'XTNA').map(join(''));

const deriveProp = (prop1, prop2) => Math.round((parseInt(prop1) + parseInt(prop2))/18*100)

const deriveProperties = (props) => { return {
  NTar: deriveProp(props.NX, props.NT),
  NPer: deriveProp(props.NN, props.NA),
  NRef: deriveProp(props.NT, props.NN),
  NAcc: deriveProp(props.NA, props.NX),
  ATar: deriveProp(props.AX, props.AT),
  APer: deriveProp(props.AN, props.AA),
  ARef: deriveProp(props.AT, props.AN),
  AAcc: deriveProp(props.AA, props.AX)
}};

const getResults = (props) => {
  const derivedProperties = deriveProperties(props);
  const changes = {
    dX: Math.abs(props.NX - props.AX),
    dT: Math.abs(props.NT - props.AT),
    dN: Math.abs(props.NN - props.AN),
    dA: Math.abs(props.NA - props.AA)
  };

  const change = changes.dX + changes.dT + changes.dN + changes.dA;
  const consistency = 1 - change/(props.NX + props.NT + props.NN + props.NA);

  const profileNames = ['EXPLORADOR', 'CONSTRUCTOR', 'CONSEJERO', 'ANIMADOR'];
  const xtna = 'XTNA'.split('');

  const getProfile = (prefix) => {
    const value = ((x) => props[prefix + xtna[x]]);
    const sort1 = (a, b) => value(a) - value(b);
    const order = [0, 1, 2, 3].sort(sort1);
    const sort2 = (a, b) => value(a) + a/10 - value(b) + b/10;
    let profileIndices = order.filter((x) => value(x) >= value(order[2])).sort(sort2);
    
    if (value(last(profileIndices)) > 6) {
      profileIndices = profileIndices.filter((x) => value(x) > 6);
    }

    const profiles = map(prop(__, profileNames), reverse(profileIndices));
    return profiles;
  };

  const NProfile = getProfile('N'), AProfile = getProfile('A');

  return {
    derivedProperties,
    changes,
    change,
    consistency,
    NProfile,
    AProfile
  };
};

const validForm = utils.validateObject(
  fromPairs(
    props.map((prop) =>
      [prop, allPass(
        [is(Number),
        lte(__, 9),
        gte(__, 0)])])));

export default {
  props: () => clone(props),
  default: () => fromPairs(props.map(compose(reverse, append(__, [1])))),
  deriveProperties,
  getResults,
  validForm
}



// WEBPACK FOOTER //
// ./src/App/xtna/XTNA.js